// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33fTf","importantInfo":"styles_importantInfo__2toDp"};